import React from "react";
import { Link } from "react-router-dom";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import styles from "./complianceBreadcrumb.module.scss";

const ComplianceBreadcrumb = ({ items }) => {
  if (!items || !items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className={styles.breadcrumb}>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={item.label} className={styles.crumb}>
            {item.href && !isLast ? (
              <Link to={item.href} className={styles.link}>
                {item.label}
              </Link>
            ) : (
              <span className={styles.current}>{item.label}</span>
            )}
            {!isLast ? (
              <ArrowForwardIosRoundedIcon className={styles.separator} />
            ) : null}
          </span>
        );
      })}
    </nav>
  );
};

export default ComplianceBreadcrumb;
